// extracted by mini-css-extract-plugin
export default {"wrapperSelect":"CourseSelection_wrapperSelect__s-JGD","select":"CourseSelection_select__LdE0P"};